/* tslint:disable:no-empty */

import * as React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { load } from "./analytics";
import AnalyticsTracker from "./components/AnalyticsTracker/AnalyticsTracker";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import FAQ from "./pages/FAQ/FAQ";
import Index from "./pages/Index/Index";
import { Privacy, Terms, Disclosures } from "./pages/Legal/Index";
import { NotFound } from "./pages/NotFound/NotFound";
import Acorns from "./pages/Acorns/Acorns";
import { ThemeProvider } from "./styled-components";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "unstated";
import reset from "styled-reset";
import { injectGlobal } from "./styled-components";
import { Careers } from "./pages/Careers/Careers";
import { ContactIssuers } from "./pages/Contact/ContactIssuers";
import { ContactBrokers } from "./pages/Contact/ContactBrokers";

export const baseStyles = () => injectGlobal`
  ${reset}

  @font-face {
    font-family: 'Lyon';
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Regular-Web.eot') format('embedded-opentype');
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Regular-Web.woff') format('woff');
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Regular-Web.woff2') format('woff2');
    font-weight: 400;
  }

  @font-face {
    font-family: 'Lyon';
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Medium-Web.eot') format('embedded-opentype');
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Medium-Web.woff') format('woff');
    src: url('https://assets.saytechnologies.com/fonts/LyonDisplay-Medium-Web.woff2') format('woff2');
    font-weight: 500;
  }

  html {
  box-sizing: border-box;
    font-family: "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
    -webkit-text-size-adjust: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }


  body {
    background: #ffffff;
    margin: 0;
  }

  button, input {
    font-family: "Inter", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .Toastify__toast--success {
    background: #11CC99 !important;
  }
`;

export const theme = {
  colors: {
    black: "#000000",
    blue: "#1968FF",
    darkgray: "#505050",
    facebook: "#4A66AD",
    gray: "#A3A6AE",
    lightGray: "#F2F2F2",
    green: "#11CC99",
    acornsGreen: "#4BC459",
    orange: "#FF8561",
    red: "#DA4D4D",
    tan: "#FCF4EA",
    teal: "#4DDABB",
    trueblack: "#000000",
    twitter: "#4D9FEB",
    white: "#fff"
  },
  fonts: {
    sans: '"Inter", "Helvetica Neue", Helvetica, Arial, sans-serif',
    serif: "'Lyon', Georgia, 'Times New Roman', serif"
  },
  tickers: {
    tsla: "#c00"
  },
  breakpoints: ["577px", "769px", "993px"]
};

class App extends React.Component<{}, {}> {
  constructor(props: {}) {
    super(props);
    load();
  }

  public render() {
    return (
      <Provider>
        <ThemeProvider theme={theme}>
          <>
            {baseStyles()}
            <Router>
              <ScrollToTop>
                <AnalyticsTracker />
                <ToastContainer />

                <Switch>
                  <Route exact={true} path="/" component={Index} />
                  <Route path="/r/:referrerCode" component={Index} />
                  <Route
                    path="/tesla"
                    component={() => {
                      (window as any).location =
                        "https://saytechnologies.com/earnings/tesla/";
                      return null;
                    }}
                  />
                  <Route
                    path="/tsla"
                    component={() => {
                      (window as any).location =
                        "https://saytechnologies.com/earnings/tesla/";
                      return null;
                    }}
                  />
                  <Route
                    path="/twitter"
                    component={() => {
                      (window as any).location =
                        "https://saytechnologies.com/earnings/twitter/";
                      return null;
                    }}
                  />
                  <Route
                    path="/twtr"
                    component={() => {
                      (window as any).location =
                        "https://saytechnologies.com/earnings/twitter/";
                      return null;
                    }}
                  />
                  <Route path="/acorns" component={Acorns} />
                  <Route path="/careers" component={Careers} />
                  <Route path="/faq" component={FAQ} />
                  <Route
                    path="/tesla/faq"
                    render={() => <Redirect to="/faq" />}
                  />
                  <Route exact={true} path="/privacy" component={Privacy} />
                  <Redirect from="/privacy/proxy" to="/privacy" />
                  <Route exact={true} path="/terms" component={Terms} />
                  <Redirect from="/terms/proxy" to="/terms" />
                  <Route
                    exact={true}
                    path="/disclosures"
                    component={Disclosures}
                  />
                  <Redirect from="/disclosures/proxy" to="/disclosures" />
                  <Route path="/issuer-contact" component={ContactIssuers} />
                  <Route path="/broker-contact" component={ContactBrokers} />
                  <Route component={NotFound} />
                </Switch>
              </ScrollToTop>
            </Router>
          </>
        </ThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx